import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

const ListWrapper = styled.div`
  a {
    color: #fff;
    text-decoration: none;
  }
  &.mobile {
    .list-item-wrapper {
      margin: 15px 0;
    }
  }
  &.desktop {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    font-size: 14px;
    @media all and (min-width: 576px) {
      font-size: 16px;
    }
    @media all and (min-width: 768px) {
      justify-content: center;
    }
    a {
      padding: 3px 8px;
      border-bottom: 1px solid rgba(0, 0, 0, 0);
      transition: all 0.3s ease;
      &:hover {
        border-bottom: 1px solid #fff;
      }
      &.active {
        border-bottom: 1px solid #fff;
      }
    }
  }
`

const ListItemWrapper = styled.div`
  text-align: center;
  margin: 0 5px;
  @media all and (min-width: 576px) {
    margin: 0 10px;
  }
  @media all and (min-width: 768px) {
    margin: 0 20px;
  }
`
const checkIfItemIsActive = itemConfig => {
  if (typeof window === "undefined") return
  return window.location.origin + itemConfig.link == window.location.href
}

export default function ListItemsComponent({ items, display }) {
  return (
    <ListWrapper className={display}>
      {items.map((e, i) => {
        return (
          <ListItemWrapper className="list-item-wrapper" key={i}>
            <Link
              className={checkIfItemIsActive(e) ? "active" : ""}
              to={e.link}
            >
              {e.name}
            </Link>
          </ListItemWrapper>
        )
      })}
    </ListWrapper>
  )
}
